import React from 'react';
import { useMediaQuery } from 'react-responsive';
import UpcomingEventsCarousel from 'components/organisms/upcomingEventsCarousel';
import UpcomingEventsMobileCarousel from 'components/organisms/upcomingEventsMobileCarousel';
import { useViewport } from 'components/templates/viewportProvider';
import './styles.scss';

const UpcomingShowsSection = props => {
  const {
    upcomingShows,
    upcomingShowsOverlayData,
    showNotificationButton,
    type,
  } = props.data;
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)',
  });
  const isBigScreen = useMediaQuery({ query: '(min-device-width: 1824px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({
    query: '(max-device-width: 1224px)',
  });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
  const { height } = useViewport();
  return (
    <div
      style={{ height }}
      id={type === 'other-shows' ? 'other-shows' : 'upcoming-shows'}
    >
      {(isDesktopOrLaptop || isBigScreen || isPortrait === false) && (
        <>
          <UpcomingEventsCarousel
            events={upcomingShows}
            showNotificationButton={showNotificationButton}
            overlayData={upcomingShowsOverlayData}
          />
        </>
      )}

      {(isTabletOrMobileDevice || isTabletOrMobile) && isPortrait === true && (
        <>
          <UpcomingEventsMobileCarousel
            events={upcomingShows}
            overlayData={upcomingShowsOverlayData}
          />
        </>
      )}
    </div>
  );
};

export default UpcomingShowsSection;
